'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Root = require('./Root');

Object.defineProperty(exports, 'AppAccount', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Root).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }